import { render, staticRenderFns } from "./SiEmailTemplate.vue?vue&type=template&id=56811afe&"
import script from "./SiEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./SiEmailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports